<template>
    <div class="context">
        <keep-alive include="tableView">
            <component
                :is="componentId"
                @changeTopTab="switchModule"
                :ref="componentId"
            >
            </component>

        </keep-alive>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import tableView from "./tableView"
    import auditView from "./auditView"

    export default {
        name: "",
        components: {
            tableView,
            auditView
        },
        data() {
            return {
                componentId: 'tableView'
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id
                if(id == 'tableView'){
                    this.$eventBus.$emit("pollPort")
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>